// Used to set the environment globally for file upload.
export const fileUploadEnvironment = "dev"